<template>
  <div>
    <button
      @click="resetModal"
      class="ui-button--amarelo"
      this.show_form="true;"
      data-target="#exampleModal"
      data-toggle="modal"
      type="button"
      data-backdrop="static"
    >
      REENCAMINHE O CÓDIGO AQUI
    </button>
    <div
      class="modal fade checkin__resend"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="show_form"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close checkin__close"
              data-dismiss="modal"
              aria-label="Close"
              @click="show_form = false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p class="checkin__resend-title">
              <span> Não localizou seu código de check-in? </span>
              <br />
              Receba novamente aqui
            </p>
            <form
              class="container ui-form"
              @submit.prevent="resendCodes"
              v-if="!show_message"
            >
              <div class="col-12" :data-wronged="error">
                <div class="login__input-wrapper">
                  <input
                    autocomplete="off"
                    id="email"
                    name="email_resend"
                    required
                    type="email"
                    v-model="email"
                  />
                  <label for="email" class="label_form">
                    E-mail do comprador*
                  </label>
                </div>
              </div>
              <div class="ui-wronged--text">{{ error }}</div>
              <button class="ui-button--verde" :disabled="button.disabled">
                <i
                  class="fa fa-spinner fa-pulse mr-2"
                  v-if="button.disabled"
                ></i>
                {{ button.text }}
              </button>
            </form>
            <div v-else>{{ message }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["endpoint", "event"],
  data() {
    return {
      email: "",
      event_id: "",
      button: {
        disabled: false,
        text: "REENCAMINHE O CÓDIGO AQUI",
      },
      error: "",
      message: "",
      show_message: false,
      show_form: false,
    };
  },
  methods: {
    resetModal() {
      this.show_message = false;
      this.show_form = true;
    },
    async resendCodes() {
      this.button = {
        disabled: true,
        text: "Enviando...",
      };
      await axios
        .post(this.endpoint, {
          email: this.email,
          event_id: this.event.id,
          event_name: this.event.year,
        })
        .then((response) => {
          this.message = response?.data?.msg;
          this.show_message = true;
        })
        .catch((error) => {
          this.error = error?.response?.data?.msg;
        });
      this.email = "";
      this.button = {
        disabled: false,
        text: "REENCAMINHE O CÓDIGO AQUI",
      };
    },
  },
};
</script>